import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, inject, Input, Loader, Modal, ModalHandle, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { BsLayoutSplit } from '@react-icons/all-files/bs/BsLayoutSplit';
import { Button, Form, FormGroup } from 'reactstrap';
import { AccountStore, IUserGridColumnPreset, IUserColumnPreset } from '../../Account/AccountStore';
import { ColumnState } from 'ag-grid-enterprise';

export interface ICreateGridColumnPresetModalProps {
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class CreateGridColumnPresetModal extends React.Component<ICreateGridColumnPresetModalProps> {
    public render() {
        return (
            <Modal
                title={this.title}
                modalHandle={this.props.modalHandle}
                footer={this.footer}
                className="p-0"
                onOpened={this.onOpenedAsync}
            >
                <div className="p-3">
                    <Form>
                        <FormGroup color={this.columnPresetForm.fields.name.state}>
                            <label>Preset Name</label>

                            <Input type="text" id="name" field={this.columnPresetForm.fields.name} required />
                        </FormGroup>
                    </Form>
                </div>
            </Modal>
        );
    }

    @bind
    @action
    private async onOpenedAsync() {
        const gridColumns = this.accountStore.tabStorage.activeGridColumns;

        this.columnPresetForm.fields.columns.value = gridColumns;
    }

    //Private Functions
    @bind
    @action
    private async submitAsync(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        const preset = this.columnPresetForm.values;
        if (!this.accountStore.storage.gridColumnPresets) this.accountStore.storage.gridColumnPresets = [];
        this.accountStore.storage.gridColumnPresets.unshift(preset);
        this.accountStore.storage.activeGridColumnPreset = preset.name;
        this.accountStore.tabStorage.activeGridColumnPreset = preset.name;
        
        this.columnPresetForm.clear();
        this.props.modalHandle.close();
    }

    //Private Fields
    private title = (
        <span className="text-header fw-bold text-center">
            <BsLayoutSplit /> Create New Column Preset
        </span>
    );

    // public component
    @computed
    private get footer() {
        return (
            <Button color="primary" onClick={this.submitAsync} disabled={this.loading}>
                <Loader loading={this.loading} showSpinner message="Creating Preset..." />
                {!this.loading && 'Create Preset'}
            </Button>
        );
    }

    @observable
    private loading = false;
    @observable
    private readonly columnPresetForm = new FormStore<IUserGridColumnPreset>({
        name: '',
        columns: [],
    });
    @inject
    private accountStore!: AccountStore;
}
